import * as types from './types'
import http from '../../utils/http'

const state = {
  inventoryList: {
    total: 0,
    rows: []
  },
  dateList: [],
  locationList: [],
  adjustmentList: {rows: []},
  historicalInventory: {},
  GoodsHistoryBatch: []
}

const actions = {
  [types.GETINVENTORYLIST] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('/api/task/queryInventoryPage', params).then(data => {
        context.commit(types.GETINVENTORYLIST, data)
        resolve(data)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  [types.GETDATEDETAILS] (context, params) {
    http.fetch('/api/task/queryGoodsByProduction', params).then(data => {
      context.commit(types.GETDATEDETAILS, data)
    })
  },
  [types.GETLOCATIONDETAILS] (context, params) {
    http.fetch('/api/task/queryGoodsByLocation', params).then(data => {
      context.commit(types.GETLOCATIONDETAILS, data)
    })
  },
  /**
   * 库存调整单
   */
  // 获取列表
  [types.GETSTOCKADJUSTPAGE] (context, params) {
    http.fetch('/api/inventoryLoss/getStockAdjustPage', params).then(data => {
      context.commit(types.GETSTOCKADJUSTPAGE, data)
    })
  },
  /**
   * 历史库存
   */
  // 获取列表
  [types.GETHISTORICALINVENTORY] (context, params) {
    http.fetch('/api/goodshistory/getGoodsHistoryPage', params).then(data => {
      context.commit(types.GETHISTORICALINVENTORY, data)
    })
  },
  // 生产日期明细
  [types.GETGOODSHISTORYBATCH] (context, params) {
    http.fetch('/api/goodshistory/getGoodsHistoryBatch', params).then(data => {
      context.commit(types.GETGOODSHISTORYBATCH, data)
    })
  }
}

const mutations = {
  [types.GETINVENTORYLIST] (state, res) {
    let D = res.obj
    state.inventoryList = {
      rows: D.records,
      total: D.total
    }
  },
  [types.GETDATEDETAILS] (state, data) {
    state.dateList = data.obj
  },
  [types.GETLOCATIONDETAILS] (state, data) {
    state.locationList = data.obj
  },
  /**
   * 库存调整单
   */
  // 获取列表
  [types.GETSTOCKADJUSTPAGE] (state, data) {
    state.adjustmentList = data
  },
  /**
   * 历史库存
   */
  // 获取列表
  [types.GETHISTORICALINVENTORY] (state, data) {
    state.historicalInventory = data
  },
  // 历史库存明细
  [types.GETGOODSHISTORYBATCH] (state, data) {
    state.GoodsHistoryBatch = data.obj
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/inventoryManage/index.js